import { render, staticRenderFns } from "./CardItemTitle.vue?vue&type=template&id=f2567ff4"
import script from "./CardItemTitle.vue?vue&type=script&lang=ts"
export * from "./CardItemTitle.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f2567ff4')) {
      api.createRecord('f2567ff4', component.options)
    } else {
      api.reload('f2567ff4', component.options)
    }
    module.hot.accept("./CardItemTitle.vue?vue&type=template&id=f2567ff4", function () {
      api.rerender('f2567ff4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/card/CardItemTitle.vue"
export default component.exports